import { Injectable } from '@angular/core';
import { EncryptDecryptService } from './encrypt-decrypt.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private encryptDecryptService: EncryptDecryptService) { }

  public set = (key: string, value: string)  =>   localStorage.setItem(key, this.encryptDecryptService.encrypt(value));


  public get(key: string) {
    let data = localStorage.getItem(key)|| "";
    return data === '' ? null : this.encryptDecryptService.decrypt(data);
  }

  public remove = (key: string) => localStorage.removeItem(key);

  public clear =() =>  localStorage.clear();


}
